import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Sparkles } from 'lucide-react'
import LucaModal from '../../../../../ui/LucaModal'
import { Button } from '../../../../../ui/index'
import CreditCardStatementApi from '../../../../../../../api/creditCardStatement.api'
import robot from '../../../../../../../assets/robot.png'

const ModalCreditCardStatementIntro = ({ isOpen, onClose, onNext, businessId }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false)
  const queryClient = useQueryClient()

  const preferenceMutation = useMutation({
    mutationFn: () => CreditCardStatementApi.setIntroPreference(businessId, true),
    onSuccess: () => {
      queryClient.setQueryData(['credit-card-statement-intro-preference', businessId], {
        hideIntro: true
      })
    }
  })

  const handleNext = () => {
    if (dontShowAgain) {
      preferenceMutation.mutate()
    }
    onNext()
  }

  return (
    <LucaModal
      open={isOpen}
      onClose={onClose}
      maxWidth='max-w-lg'
      footer={
        <>
          <Button
            title='Cerrar'
            onClick={onClose}
            className='text-[10px] bg-primary text-white rounded-full'
          />
          <Button
            title='Siguiente'
            onClick={handleNext}
            className='text-[10px] bg-accent2 text-white rounded-full'
          />
        </>
      }
    >
      <div className='flex-1 overflow-y-auto p-8 flex flex-col items-center text-center'>
        <div className='relative mb-5 flex h-24 w-24 items-center justify-center'>
          <span className='absolute inset-0 rounded-full bg-accent2/20 blur-xl animate-pulse' aria-hidden />
          <span className='relative flex h-20 w-20 items-center justify-center rounded-full bg-primary shadow-xl ring-4 ring-accent2/20'>
            <img src={robot} alt='Luca AI' draggable={false} className='h-14 w-14 object-contain' />
          </span>
          <span className='absolute -right-1 -top-1 flex h-7 w-7 items-center justify-center rounded-full bg-accent2 shadow-md ring-2 ring-white'>
            <Sparkles size={14} className='text-white' />
          </span>
        </div>

        <div className='mb-1 inline-flex items-center gap-1.5 rounded-full bg-accent2/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-accent2'>
          <Sparkles size={12} />
          Extracción con TryLuca
        </div>

        <h3 className='mt-3 text-lg font-bold text-slate-900'>
          Sube tu PDF de movimientos de tarjeta de crédito
        </h3>
        <p className='mt-2 text-sm text-slate-500 max-w-sm'>
          Sube tu PDF de los movimientos de la tarjeta de crédito y TryLuca extraerá y guardará todos los movimientos.
        </p>

        <label className='mt-6 flex items-center gap-2 text-xs font-semibold text-slate-600 cursor-pointer select-none'>
          <input
            type='checkbox'
            checked={dontShowAgain}
            onChange={event => setDontShowAgain(event.target.checked)}
            className='h-4 w-4 rounded border-gray-300 text-accent2 focus:ring-accent2'
          />
          No volver a recordar
        </label>
      </div>
    </LucaModal>
  )
}

export default ModalCreditCardStatementIntro
